export default __webpack_public_path__ + "static/media/320px-Flag_of_Cantabria.svg.f32a2007.png";